import { BOARD_SIZE } from "@word-duel/shared";
import type { PremiumType } from "@word-duel/shared";

export type PremiumCoordinate = readonly [row: number, col: number];

const coordinates = {
  TW: [
    [0, 0],
    [0, 7],
    [0, 14],
    [7, 0],
    [7, 14],
    [14, 0],
    [14, 7],
    [14, 14]
  ],
  DW: [
    [1, 1],
    [1, 13],
    [2, 2],
    [2, 12],
    [3, 3],
    [3, 11],
    [4, 4],
    [4, 10],
    [7, 7],
    [10, 4],
    [10, 10],
    [11, 3],
    [11, 11],
    [12, 2],
    [12, 12],
    [13, 1],
    [13, 13]
  ],
  TL: [
    [1, 5],
    [1, 9],
    [5, 1],
    [5, 5],
    [5, 9],
    [5, 13],
    [9, 1],
    [9, 5],
    [9, 9],
    [9, 13],
    [13, 5],
    [13, 9]
  ],
  DL: [
    [0, 3],
    [0, 11],
    [2, 6],
    [2, 8],
    [3, 0],
    [3, 7],
    [3, 14],
    [6, 2],
    [6, 6],
    [6, 8],
    [6, 12],
    [7, 3],
    [7, 11],
    [8, 2],
    [8, 6],
    [8, 8],
    [8, 12],
    [11, 0],
    [11, 7],
    [11, 14],
    [12, 6],
    [12, 8],
    [14, 3],
    [14, 11]
  ]
} as const satisfies Readonly<Record<PremiumType, readonly PremiumCoordinate[]>>;

export const PREMIUM_COORDINATES: Readonly<Record<PremiumType, readonly PremiumCoordinate[]>> =
  Object.freeze(coordinates);

const premiumBoard: Array<PremiumType | null> = Array.from(
  { length: BOARD_SIZE * BOARD_SIZE },
  () => null
);

for (const premium of ["DL", "TL", "DW", "TW"] as const) {
  for (const [row, col] of PREMIUM_COORDINATES[premium]) {
    const index = row * BOARD_SIZE + col;
    if (premiumBoard[index] !== null) {
      throw new Error(`Duplicate premium coordinate at ${row},${col}.`);
    }
    premiumBoard[index] = premium;
  }
}

export const PREMIUM_BOARD: readonly (PremiumType | null)[] = Object.freeze(premiumBoard);

export function getPremiumAt(row: number, col: number): PremiumType | null {
  if (
    !Number.isInteger(row) ||
    !Number.isInteger(col) ||
    row < 0 ||
    col < 0 ||
    row >= BOARD_SIZE ||
    col >= BOARD_SIZE
  ) {
    return null;
  }
  return PREMIUM_BOARD[row * BOARD_SIZE + col] ?? null;
}

export function letterMultiplier(premium: PremiumType | null): number {
  if (premium === "DL") return 2;
  if (premium === "TL") return 3;
  return 1;
}

export function wordMultiplier(premium: PremiumType | null): number {
  if (premium === "DW") return 2;
  if (premium === "TW") return 3;
  return 1;
}
